import React from 'react';
import { cn } from '@/utils';
import { TextContent } from '@/components';

export interface LinkCellProps {
  /** Link text to display */
  children: React.ReactNode;
  /** Click handler for the link */
  onClick?: () => void;
  /** Link href if using as anchor */
  href?: string;
  /** Additional CSS classes */
  className?: string;
  /** Disabled state */
  disabled?: boolean;
}

/**
 * LinkCell Component
 *
 * Displays clickable links in table cells with consistent styling
 * based on the Figma design.
 */
export const LinkCell: React.FC<LinkCellProps> = ({
  children,
  onClick,
  href,
  className,
  disabled = false,
}) => {
  const baseClasses = cn(
    'text-sm leading-5 text-neutral-gray-700 underline decoration-solid cursor-pointer',
    'hover:text-neutral-black transition-colors',
    disabled && 'opacity-50 cursor-not-allowed pointer-events-none',
    className
  );

  if (href && !onClick) {
    return (
      <a href={href} className={baseClasses}>
        {children}
      </a>
    );
  }

  return (
    <button 
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={baseClasses}
    >
      {children}
    </button>
  );
};

LinkCell.displayName = 'LinkCell';